import { render, staticRenderFns } from "./RubricForm.vue?vue&type=template&id=6d74e930&scoped=true&"
import script from "./RubricForm.vue?vue&type=script&lang=ts&"
export * from "./RubricForm.vue?vue&type=script&lang=ts&"
import style0 from "./RubricForm.vue?vue&type=style&index=0&id=6d74e930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74e930",
  null
  
)

export default component.exports